interface InitialsAvatarProps {
  name: string;
  size?: number;
  className?: string;
}

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  if (/[\u4e00-\u9fa5]/.test(trimmed)) {
    return trimmed.slice(0, 2);
  }
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return trimmed.slice(0, 2).toUpperCase();
}

export default function InitialsAvatar({ name, size = 48, className = "" }: InitialsAvatarProps) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading font-semibold text-primary-700 ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.36 }}
      aria-hidden="true"
    >
      {getInitials(name)}
    </div>
  );
}